export const translations = {
  fr: {
    meta: {
      title: 'Yannis Alouache - Développeur Full-Stack',
      description:
        "Portfolio de Yannis Alouache, développeur full-stack orienté back-end basé à Lille (NestJS, Spring Boot, TypeScript). Software craftsmanship, TDD et développement assisté par l'IA : Claude Code, MCP, spec-driven development.",
    },
    nav: {
      skills: 'Compétences',
      ai: 'IA',
      projects: 'Projets',
      home: 'Accueil',
      contactCta: 'Me contacter',
      menu: 'Menu',
      openMenu: 'Ouvrir le menu',
      closeMenu: 'Fermer le menu',
      navDialog: 'Menu de navigation',
      switchAria: 'Changer de langue',
    },
    hero: {
      badge: 'Disponible pour de nouvelles opportunités',
      sub: "Développeur full-stack basé à Lille, appétence back-end. Passionné par l'intelligence artificielle, je conçois des applications web robustes : architecture soignée, tests, code maintenable.",
      ctaProjects: 'Voir mes projets',
      ctaResume: 'Télécharger le CV',
      role: 'Développeur full-stack',
      statProjects: 'Projets livrés',
      statFreelance: 'Missions freelance',
      statYears: "Années d'expérience",
      avatarAlt: 'Avatar de Yannis Alouache',
    },
    skills: {
      title: 'Ma boîte à outils',
      sub: "Les technologies que j'utilise au quotidien pour concevoir, développer et déployer des applications web complètes.",
      groups: {
        backend: 'Back-end',
        frontend: 'Front-end',
        tools: 'Outils & environnements',
        ai: 'IA & développement assisté',
      },
    },
    ai: {
      title: "L'IA dans ma façon de travailler",
      sub: 'Claude Code fait partie de mon outillage quotidien, encadré par des méthodes qui garantissent la qualité de ce qui est produit.',
      steps: [
        {
          title: 'Spécifier',
          desc: "Chaque projet démarre par un cadrage écrit : besoin, périmètre, critères d'acceptation. Le code ne commence qu'une fois ce cadre posé.",
        },
        {
          title: 'Planifier',
          desc: "Avant la première ligne de code, un plan détaillé est rédigé puis revu. L'IA itère sur la spécification, jamais dans le flou.",
        },
        {
          title: 'Implémenter',
          desc: 'Claude Code travaille en binôme : petites étapes, commits fréquents, skills et serveurs MCP configurés pour chaque projet.',
        },
        {
          title: 'Vérifier',
          desc: "Des tests automatisés sont systématiquement mis en place pour valider chaque feature produite avec l'IA. Chaque diff généré est relu avant d'être intégré.",
        },
      ],
      noteTitle: 'Concrètement :',
      note: "des itérations plus rapides, un cadrage plus solide et plus de temps pour l'architecture. L'outillage change, pas l'exigence.",
    },
    projects: {
      title: 'Projets sélectionnés',
      sub: "Des sites livrés pour des clients freelance et des projets personnels qui m'ont fait grandir. Cliquez sur une carte pour explorer le projet en détail.",
      cta: 'Voir le projet',
      badges: {
        freelance: 'Freelance',
        personal: 'Projet perso',
        student: 'Projet étudiant',
      },
      descriptions: {
        Delizo: 'SaaS de commande et paiement à table par QR code pour les restaurants.',
        'Falcon Marketing': 'Site vitrine pour une agence de recrutement de commerciaux.',
        MyCarz: 'Site vitrine pour un garage automobile de Roubaix.',
        'E-Taxi': 'Plateforme de réservation de taxis dans le Nord.',
        Drivetty: 'Marketplace automobile entre particuliers (C2C).',
        'Poke-Maniaque': 'Explorateur pour visualiser toutes les cartes Pokémon.',
        AngryLLama: "Site vitrine d'une collection de NFT que j'ai créée.",
        GothicVania: "Jeu vidéo de type runner inspiré de l'univers Castlevania.",
        OBarbeuc: 'Site de restaurant fictif, réalisé en école.',
      },
      tags: {
        Réservation: 'Réservation',
        'Jeu vidéo': 'Jeu vidéo',
      },
    },
    contact: {
      title: 'Travaillons ensemble.',
      text: "Un projet, une question, une opportunité ? N'hésitez pas à me contacter, je serai ravi d'échanger avec vous autour de vos idées.",
      fields: {
        lastName: 'Nom',
        firstName: 'Prénom',
        mail: 'E-mail',
        phone: 'Téléphone',
        message: 'Message',
      },
      errors: {
        lastName: 'Entrez un nom',
        firstName: 'Entrez un prénom',
        mail: 'Entrez un e-mail valide',
        phone: 'Entrez un numéro de téléphone valide',
        message: 'Entrez un message',
        send: 'Une erreur est survenue, réessayez ou écrivez-moi directement par e-mail.',
      },
      success: 'Message envoyé ! Je vous réponds au plus vite.',
      submit: 'Envoyer le message',
      cvAria: 'Télécharger mon CV',
    },
    detail: {
      back: 'Retour aux projets',
      visit: 'Visiter le site',
      notHosted: 'Non hébergé pour le moment',
      viewGithub: 'Voir sur GitHub',
      tech: 'Technologies utilisées',
      gallery: 'Galerie',
      preview: 'Aperçu',
    },
    details: {
      Delizo:
        "Delizo est un SaaS de commande à table pour les restaurants. Le client scanne le QR code de sa table, consulte le menu, commande et paie depuis son téléphone ; la commande arrive en cuisine en temps réel. Le restaurateur gère son menu, ses photos et ses statistiques depuis un back-office, et encaisse directement sur son compte Stripe, sans commission.",
      AngryLLama: "AngryLLama est un site vitrine présentant une collection de NFT que j'ai créée.",
      GothicVania: "GothicVania est un jeu vidéo de type runner inspiré de l'univers Castlevania.",
      OBarbeuc: 'OBarbeuc est un site présentant un restaurant fictif.',
      'Poke-Maniaque': 'Poke-Maniaque est un site qui permet de visualiser toutes les cartes Pokémon.',
      Drivetty: 'Drivetty est une marketplace automobile entre particuliers (C2C).',
      'E-Taxi': 'E-Taxi est un site de réservation de taxi réalisé pour un client.',
      'Falcon Marketing': "Falcon Marketing est le site d'une agence de recrutement de commerciaux.",
      MyCarz: 'MyCarz est le site d\'un garage automobile situé à Roubaix.',
    },
  },
  en: {
    meta: {
      title: 'Yannis Alouache - Full-Stack Developer',
      description:
        'Portfolio of Yannis Alouache, a back-end focused full-stack developer based in Lille, France (NestJS, Spring Boot, TypeScript). Software craftsmanship, TDD and AI-assisted development: Claude Code, MCP, spec-driven development.',
    },
    nav: {
      skills: 'Skills',
      ai: 'AI',
      projects: 'Projects',
      home: 'Home',
      contactCta: 'Get in touch',
      menu: 'Menu',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      navDialog: 'Navigation menu',
      switchAria: 'Switch language',
    },
    hero: {
      badge: 'Available for new opportunities',
      sub: 'Full-stack developer based in Lille, France, with a strong back-end focus. Passionate about artificial intelligence, I design robust web applications: clean architecture, tests, maintainable code.',
      ctaProjects: 'View my projects',
      ctaResume: 'Download CV',
      role: 'Full-stack developer',
      statProjects: 'Projects delivered',
      statFreelance: 'Freelance projects',
      statYears: 'Years of experience',
      avatarAlt: 'Yannis Alouache avatar',
    },
    skills: {
      title: 'My toolbox',
      sub: 'The technologies I use every day to design, build and deploy complete web applications.',
      groups: {
        backend: 'Back-end',
        frontend: 'Front-end',
        tools: 'Tools & environments',
        ai: 'AI & assisted development',
      },
    },
    ai: {
      title: 'AI in my workflow',
      sub: 'Claude Code is part of my daily tooling, framed by methods that guarantee the quality of what gets shipped.',
      steps: [
        {
          title: 'Specify',
          desc: 'Every project starts with a written brief: needs, scope, acceptance criteria. Code only begins once that framework is in place.',
        },
        {
          title: 'Plan',
          desc: 'Before the first line of code, a detailed plan is written and then reviewed. The AI iterates on the specification, never on vague ground.',
        },
        {
          title: 'Implement',
          desc: 'Claude Code works as a pair programmer: small steps, frequent commits, skills and MCP servers configured for each project.',
        },
        {
          title: 'Verify',
          desc: 'Automated tests are systematically set up to validate every feature built with AI. Every generated diff is reviewed before being merged.',
        },
      ],
      noteTitle: 'In practice:',
      note: "faster iterations, stronger upfront framing and more time for architecture. The tooling changes, the standards don't.",
    },
    projects: {
      title: 'Selected projects',
      sub: 'Sites delivered for freelance clients and personal projects that helped me grow. Click a card to explore the project in detail.',
      cta: 'View project',
      badges: {
        freelance: 'Freelance',
        personal: 'Personal project',
        student: 'Student project',
      },
      descriptions: {
        Delizo: 'QR-code table ordering and payment SaaS for restaurants.',
        'Falcon Marketing': 'Showcase website for a sales-recruitment agency.',
        MyCarz: 'Showcase website for a car garage in Roubaix.',
        'E-Taxi': 'Taxi booking platform in the Lille region.',
        Drivetty: 'Car marketplace connecting private sellers and buyers (C2C).',
        'Poke-Maniaque': 'Explorer to browse every Pokémon card.',
        AngryLLama: 'Showcase website for an NFT collection I created.',
        GothicVania: 'Runner-style video game inspired by the Castlevania universe.',
        OBarbeuc: 'Fictional restaurant website, built as a school project.',
      },
      tags: {
        Réservation: 'Booking',
        'Jeu vidéo': 'Video game',
      },
    },
    contact: {
      title: "Let's work together.",
      text: "A project, a question, an opportunity? Feel free to reach out, I'd be happy to discuss your ideas.",
      fields: {
        lastName: 'Last name',
        firstName: 'First name',
        mail: 'Email',
        phone: 'Phone',
        message: 'Message',
      },
      errors: {
        lastName: 'Enter a last name',
        firstName: 'Enter a first name',
        mail: 'Enter a valid email',
        phone: 'Enter a valid phone number',
        message: 'Enter a message',
        send: 'Something went wrong. Please try again or email me directly.',
      },
      success: "Message sent! I'll get back to you as soon as possible.",
      submit: 'Send message',
      cvAria: 'Download my CV',
    },
    detail: {
      back: 'Back to projects',
      visit: 'Visit website',
      notHosted: 'Not hosted yet',
      viewGithub: 'View on GitHub',
      tech: 'Technologies used',
      gallery: 'Gallery',
      preview: 'Preview',
    },
    details: {
      Delizo:
        'Delizo is a table-ordering SaaS for restaurants. Guests scan the QR code on their table, browse the menu, order and pay from their phone; the order reaches the kitchen in real time. The restaurant owner manages the menu, photos and statistics from a back-office, and gets paid directly to their own Stripe account, with zero commission.',
      AngryLLama: 'AngryLLama is a showcase website presenting an NFT collection I created.',
      GothicVania: 'GothicVania is a runner-style video game inspired by the Castlevania universe.',
      OBarbeuc: 'OBarbeuc is a website presenting a fictional restaurant.',
      'Poke-Maniaque': 'Poke-Maniaque is a website to browse every Pokémon card.',
      Drivetty: 'Drivetty is a car marketplace connecting private sellers and buyers (C2C).',
      'E-Taxi': 'E-Taxi is a taxi booking website built for a client.',
      'Falcon Marketing': 'Falcon Marketing is the website of a sales-recruitment agency.',
      MyCarz: 'MyCarz is the website of a car garage located in Roubaix.',
    },
  },
}
